// extracted by mini-css-extract-plugin
export default {"background_container":"SystemLock_background_container__2f2jQ","mainTitle":"SystemLock_mainTitle__0SD5E","pBlock1":"SystemLock_pBlock1__x5NSe"};